import { useEffect } from 'react';

import releaseFiles from 'virtual:release-notes';

import { PlatformStatus } from '../../../components/PlatformStatus';
import { buildEntries, type Entry, type Tag } from './changelogEntries';

// Built from the release files at build time: the deploy skill writes one per tag, and the
// dashboard's What's new log reads the same ones. Nothing here is edited by hand.
const ENTRIES: Entry[] = buildEntries(releaseFiles);

const TAG_LABEL: Record<Tag, string> = {
  new: 'New',
  fix: 'Fix',
  imp: 'Improved',
};

export function Changelog() {
  useEffect(() => {
    document.title = 'Changelog — Revvly Platform Updates';
    const slug = window.location.hash.replace(/^#/, '');
    const target = slug ? document.getElementById(slug) : null;
    if (target) {
      target.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="tn-page">
      <header className="dp-header">
        <span className="rv-eyebrow-mini">Changelog</span>
        <h1>
          What we shipped, <em>recently</em>.
        </h1>
        <p className="dp-oneliner">A running log of notable changes to Revvly.</p>
        <PlatformStatus withLatest />
      </header>
      {ENTRIES.map((e) => (
        <div key={e.v} id={e.v} className="tn-changelog-entry">
          <div className="tn-cl-head">
            <div className="tn-cl-version">{e.v}</div>
            <div className="tn-cl-date">{e.d}</div>
          </div>
          <ul className="tn-cl-list">
            {e.items.map(([tag, text], j) => (
              <li key={j}>
                <span className={`tn-cl-tag tn-cl-tag-${tag}`}>{TAG_LABEL[tag]}</span>
                {text}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
